import React from 'react';
import { Button, Divider, Form, Grid, Header, Loader, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import ThreeColumnTableRow from '../../Admin/CreateCourse/ThreeColumnTableRow';
import { toast, ToastContainer } from 'react-toastify';

export default class StudentRecognitionDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            student: JSON.parse(localStorage.getItem('student')),
            index: localStorage.getItem('index'),
            grade: null,
            course: null,
            newCourse: '',
            semesterNum: '',
            date: new Date(),
            type: 1,
            semesters: [],
            studyProgramSemesters: '',
        };

        this.getStudentsInfo = this.getStudentsInfo.bind(this);
        this.getStudyProgramSemesters = this.getStudyProgramSemesters.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.sendData = this.sendData.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.getStudentsInfo();
        this.getStudyProgramSemesters();
        localStorage.setItem('studyProgramSemesters', JSON.stringify(this.state.studyProgramSemesters));
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    getStudentsInfo() {
        if (!this.state.student.locked) {
            this.setState({ loader: true });
            axios.get(`/students/info-for-exam-recognition/${this.state.student.studentId}/${this.state.student.studyProgramStudentSwitchedToId}/`)
                .then(res => {
                    let studentsInfo = res.data[0];
                    this.setState({ studentsInfo, loader: false });
                    localStorage.setItem('newStudyProgram', JSON.stringify(studentsInfo));
                })
                .catch(err => {
                    console.log('Failed to fetch study programs');
                });
        } else {
            this.setState({ loader: false });
        }
    }

    getStudyProgramSemesters() {
        axios.get(`/study-programs/study-program-semesters/${this.state.student.studyProgramStudentSwitchedToId}/`)
            .then(res => {
                this.setState({
                    semesters: res.data.map(el => ({
                        key: el.id, value: el.id, text: el.name
                    })),
                    loader: false,
                });
            });
    }

    sendData() {
        let obj = {
            studentStudyProgramId: this.state.studentsInfo.id,
            studyProgramSemester: { id: this.state.studyProgramSemesters },
        };

        axios.put('/students/semester-ssp-starts-from/', { ...obj })
            .then(res => {
                toast('Studentu je uspješno odabran semestar.');
                this.setState({
                    loader: false
                });
                localStorage.setItem('studyProgramSemesters', JSON.stringify(this.state.studyProgramSemesters));
                this.getStudentsInfo();
            })
            .catch(err => {
                this.setState({ loader: false });
                if (err.response.data === 'Semester student starts from is already set!') {
                    toast('Studentu je već odabran semestar!');
                } else {
                    toast('Došlo je do greške! Studentu nije odabran semestar.');
                }
            });
    }

    render() {
        return (
            <div>
                {!this.state.student.locked ?
                    this.state.studentsInfo ? this.state.studentsInfo.semesterStudentStartsFrom === null ?
                        <Segment secondary clearing>
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Field required>
                                        <label>
                                            Semestar od kojeg student počinje studij na trenutnom nastavnom planu i programu
                                        </label>
                                        <Form.Dropdown
                                            placeholder="Odaberite semestar"
                                            search
                                            fluid
                                            selection
                                            options={this.state.semesters}
                                            onChange={this.handleInputChange}
                                            value={this.state.studyProgramSemesters}
                                            name="studyProgramSemesters"
                                            clearable

                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>&nbsp;</label>
                                        <Form.Button
                                            basic
                                            content="Potvrdi semestar"
                                            fluid
                                            color={!this.state.studyProgramSemesters ? 'red' : 'blue'}
                                            floated="right"
                                            disabled={!this.state.studyProgramSemesters}
                                            onClick={this.sendData}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                        </Segment>
                        : <br /> : <Loader inline="centered" active /> : <p><br />Nema podataka o ovome studentu.</p>}

                {!this.state.student.locked ?
                    <Grid columns={2}>
                        <Grid.Column> <Divider horizontal>
                            <Header as="h4">
                                Podaci sa prethodnog studijskog programa
                            </Header>
                        </Divider>
                            { this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active /> </div> : <Table celled unstackable compact>
                            <Table.Body>
                                    <ThreeColumnTableRow
                                    name="Index"
                                    keyName="index"
                                    value={this.state.student.index ? this.state.student.index : this.state.index}
                                />
                                    <ThreeColumnTableRow
                                    name="Studijski program"
                                    keyName="studyProgram"
                                    value={this.state.student.studyProgramBasicName ? this.state.student.studyProgramBasicName : ''}
                                />
                                    <ThreeColumnTableRow
                                    name="Nastavni plan i program"
                                    keyName="studyProgramImplementation"
                                    value={this.state.student.studyProgramName ? this.state.student.studyProgramName : ''}
                                />
                                    <ThreeColumnTableRow
                                    name="Zadnji upisani semestar"
                                    keyName="previousStudyProgramSemester"
                                    value={this.state.student.studyProgramSemesterName ? this.state.student.studyProgramSemesterName : ''}
                                />

                                </Table.Body>
                        </Table>}
                        </Grid.Column>
                        <Grid.Column>
                            <Divider horizontal>
                                <Header as="h4">
                                    Podaci sa trenutnog studijskog programa
                                </Header>
                            </Divider>
                            {this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active /> </div> : <Table celled unstackable compact>

                                <Table.Body>
                                    <ThreeColumnTableRow
                                        name="Index"
                                        keyName="index"
                                        value={this.state.studentsInfo ? this.state.studentsInfo.index : ''}
                                    />

                                    <ThreeColumnTableRow
                                        name="Studijski program"
                                        keyName="studyProgram"
                                        value={this.state.studentsInfo ? this.state.studentsInfo.studyProgramBasicName : ''}

                                    />
                                    <ThreeColumnTableRow
                                        name="Nastavni plan i program"
                                        keyName="newStudyProgram"
                                        value={this.state.studentsInfo ? this.state.studentsInfo.studyProgramName : ''}
                                    />
                                    <ThreeColumnTableRow
                                        name="Prvi upisani semestar"
                                        keyName="currentStudyProgramSemester"
                                        value={this.state.studentsInfo ? this.state.studentsInfo.semesterStudentStartsFrom : ''}
                                    />


                                </Table.Body>
                            </Table>}
                        </Grid.Column>
                    </Grid> : '' }
                {/*<p><br />Nema podataka o ovome studentu.</p>*/}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ExamRecognition/StudentRecognitionDetails.js